/**
 * group-card-mobile.js
 */

import React from 'react';
import { Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import Card from 'components/card';
import Icon from 'components/icon';


export default function GroupCardMobile(props) {
  const { iconType, title, count, route, description } = props;
  
  return <>
    <Card sx={{ p: 2, textDecoration: 'none' }} component={Link} to={route}>
      <div className={`flex-hc`}>
        <Icon type={iconType} fontSize='large' sx={{ mr: 1.5 }} />
        <Typography variant='subtitle1' sx={{ flex: 1, fontSize: 'sizes.4' }}>{title} ({count})</Typography>
        <MuiLink component={'span'} underline="hover">View All</MuiLink>
      </div>
      <Typography variant='subtext-large' sx={{ mt: 2 }}>{description}</Typography>
    </Card>
  </>;
}